/**
 * @zongheng/core-schema 公共入口。
 */
export * from './types.ts';
export * from './schedule.ts';
export * from './protocol.ts';
export * from './crypto.ts';
export * from './motion.ts';

import seedSource from './data/ai-glasses-2026.json';
import { resolveMotionPackage, type MotionPackageSource } from './motion.ts';
import type { MotionPackage } from './types.ts';

/** 内置题库《当 AI 眼镜可以即时提供答案，知识的价值正在消失/并未消失》 */
export const AI_GLASSES_MOTION: MotionPackage = resolveMotionPackage(
  seedSource as unknown as MotionPackageSource,
);

/** 默认题库注册表（Phase 1 仅内置一卷，结构上支持扩展） */
export const MOTION_REGISTRY: Record<string, MotionPackage> = {
  [AI_GLASSES_MOTION.motionId]: AI_GLASSES_MOTION,
};

export function getMotionPackage(motionId: string): MotionPackage {
  const motion = MOTION_REGISTRY[motionId];
  if (!motion) throw new Error(`未知题库：${motionId}`);
  return motion;
}
